import Button from "../components/ui/Button";
import Icon from "../components/ui/Icons";
import Contact from "../components/sections/Contact";
import heroPhoto from "../assets/photos/flota-kenworth-sierra.jpg";
import { SEO_PAGES } from "../seo/pagesContent";
import { NAP, telHref, whatsappHref, mapsEmbedSrc, mapsHref } from "../seo/site";
import "./SeoPage.css";

// City and service landing pages (src/seo/pagesContent.js): one <h1>, the
// page's own copy, FAQ (also published as FAQPage schema), map + NAP and the
// same quote form as the home page.
export default function SeoPage({ route }) {
  const page = SEO_PAGES[route.pageId];

  return (
    <>
      <section className="seo-hero section--dark">
        <div className="seo-hero-media" aria-hidden="true">
          <img src={heroPhoto} alt="" />
          <div className="seo-hero-scrim" />
        </div>
        <div className="container seo-hero-inner">
          <nav className="seo-breadcrumb" aria-label="Ruta de navegación">
            <a href="/">Inicio</a>
            <span aria-hidden="true">›</span>
            <span aria-current="page">{page.breadcrumb}</span>
          </nav>
          <p className="eyebrow on-dark">{page.hero.eyebrow}</p>
          <h1 className="seo-hero-title">{page.hero.h1}</h1>
          <p className="seo-hero-lead">{page.hero.lead}</p>
          <div className="seo-hero-ctas">
            <Button href="#contacto" variant="primary" arrow>
              Cotizar flete
            </Button>
            <Button href={telHref} variant="secondary">
              Llamar al {NAP.phoneDisplay}
            </Button>
          </div>
        </div>
      </section>

      <section className="section seo-body">
        <div className="container seo-narrow">
          {page.sections.map((s) => (
            <div className="seo-block" key={s.title}>
              <h2 className="seo-block-title">{s.title}</h2>
              {s.paragraphs?.map((p) => (
                <p key={p.slice(0, 40)}>{p}</p>
              ))}
              {s.list && (
                <ul className="seo-list">
                  {s.list.map((item) => (
                    <li key={item.slice(0, 40)}>
                      <Icon name="check" size={18} />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}
              {s.note && <p className="seo-note">{s.note}</p>}
            </div>
          ))}
        </div>
      </section>

      <section className="section section--alt seo-faq" aria-labelledby="faq-title">
        <div className="container seo-narrow">
          <p className="eyebrow">Preguntas frecuentes</p>
          <h2 id="faq-title" className="section-title">
            Lo que nos preguntan antes de cotizar
          </h2>
          <div className="seo-faq-list">
            {page.faqs.map((f) => (
              <details key={f.q} className="seo-faq-item">
                <summary>
                  <span>{f.q}</span>
                  <Icon name="chevronDown" size={18} />
                </summary>
                <p>{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="section seo-location" aria-labelledby="ubicacion-title">
        <div className="container seo-location-grid">
          <div className="seo-nap">
            <p className="eyebrow">Dónde estamos</p>
            <h2 id="ubicacion-title" className="section-title">
              {NAP.name}
            </h2>
            <address>
              <a href={mapsHref} target="_blank" rel="noopener noreferrer" className="seo-nap-row">
                <Icon name="mapPin" size={18} />
                <span>{NAP.addressLine}</span>
              </a>
              <a href={telHref} className="seo-nap-row">
                <Icon name="phone" size={18} />
                <span>{NAP.phoneDisplay}</span>
              </a>
              <a href={`mailto:${NAP.email}`} className="seo-nap-row">
                <Icon name="mail" size={18} />
                <span>{NAP.email}</span>
              </a>
            </address>
            <div className="seo-nap-ctas">
              <Button href="#contacto" variant="primary" arrow>
                Cotizar flete
              </Button>
              <Button href={whatsappHref("Hola, quiero cotizar un flete.")} variant="outline">
                WhatsApp
              </Button>
            </div>
          </div>
          <div className="seo-map">
            <iframe
              title={`Mapa: ${NAP.name}, ${NAP.addressLine}`}
              src={mapsEmbedSrc}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      <section className="section section--sm section--alt seo-related" aria-labelledby="related-title">
        <div className="container">
          <h2 id="related-title" className="seo-block-title">
            También le puede interesar
          </h2>
          <ul className="seo-related-list">
            {page.related.map((id) => (
              <li key={id}>
                <a href={SEO_PAGES[id].path} className="seo-related-card">
                  <span>{SEO_PAGES[id].hero.h1}</span>
                  <Icon name="arrowRight" size={18} />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <Contact />
    </>
  );
}
